// extracted by mini-css-extract-plugin
export default {"circle":"PastilleScore_circle__aD9mY"};